import * as apis from '@/apis/numberShare';
import * as actions from '@/actions';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  NUMBER_SHARE_ELIGIBILITY_REQUEST,
  NUMBER_SHARE_REQUEST,
  SERVICE_NUMBER_SHARE_REQUEST
} from '@/actions/numberShare/actionTypes';
import { IGetNumberShareEligibilityPayload } from '@/actions/numberShare/models/types';

function* getNumberShare() {
  try {
    const result = yield call(apis.getNumberShareDetails);
    yield put(actions.getNumberShare.success(result.data));
  } catch (error) {
    yield put(actions.getNumberShare.failure(error));
  }
}

function* getServiceNumberShare() {
  try {
    const result = yield call(apis.getServiceNumberShare);
    yield put(actions.getServiceNumberShare.success(result.data));
  } catch (error) {
    yield put(actions.getServiceNumberShare.failure(error));
  }
}

function* getNumberShareEligibility({ serviceNo, callback }: IGetNumberShareEligibilityPayload) {
  try {
    const result = yield call(apis.getNumberShareEligibility, serviceNo);
    yield put(actions.getNumberShareEligibility.success(result.data));
    callback(result.data);
  } catch (error) {
    yield put(actions.getNumberShareEligibility.failure(error));
  }
}

export default function* numberShareSagas() {
  yield takeLatest(NUMBER_SHARE_REQUEST, getNumberShare);
  yield takeLatest(SERVICE_NUMBER_SHARE_REQUEST, getServiceNumberShare);
  yield takeLatest(NUMBER_SHARE_ELIGIBILITY_REQUEST, getNumberShareEligibility);
}
